import {observable, action, autorun} from 'mobx';
import CLIENT from './Client';
import UI from './UI';

let CONTENT = observable({
  general: null,
  info: null,
  currentText: null,
  currentEvent: null,
  texts: [],
  events: [],
  pastEvents: []
})

// General stuff
CLIENT
  .getEntries({
    'sys.id': '5UDSnnmNYQ6MauAIGyC2qw',
    resolveLinks: true,
    include: 10
  }).then((response) => {
    CONTENT.general = response.items[0].fields

    // Texts
    CLIENT
      .getEntries({
        'content_type': 'text',
        resolveLinks: true,
        include: 10
      }).then((response) => {
        CONTENT.texts = response.items
        const slugs = UI.currentPath.split('/')
        if (slugs[1] === 'texts' && slugs[2]) {
          CONTENT.currentText = response.items.find((item) => item.fields.slug === slugs[2])
        } else {
          CONTENT.currentText = CONTENT.general.featuredText
        }
      })

    // Upcoming Events
    CLIENT
      .getEntries({
        'content_type': 'event',
        'fields.end[gte]': new Date(),
        'order': 'fields.end',
        resolveLinks: true,
        include: 10
      }).then((response) => {
        CONTENT.events = response.items
      })

    CLIENT
      .getEntries({
        'content_type': 'event',
        'fields.end[lt]': new Date(),
        'order': 'fields.end',
        resolveLinks: true,
        include: 10
      }).then((response) => {
        CONTENT.pastEvents = response.items
      })

    // Info page
    CLIENT
      .getEntries({
        'sys.id': '20sCpVp0FCWK2iAioecumu',
        resolveLinks: true,
        include: 10
      }).then((response) => {
        CONTENT.info = response.items[0].fields
      })
  })



export default CONTENT



// WEBPACK FOOTER //
// ./app/javascript/packs/stores/Content.js